export default __webpack_public_path__ + "static/media/03.ba2e37db.jpg";